"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _DownOutlined = _interopRequireDefault(require("@ant-design/icons/DownOutlined"));

var _UpOutlined = _interopRequireDefault(require("@ant-design/icons/UpOutlined"));

var _popover = _interopRequireDefault(require("antd/lib/popover"));

var _useButtonSettings2 = _interopRequireDefault(require("../../hooks/useButtonSettings"));

var _useMobilePages2 = require("../hooks/useMobilePages");

var _Partials = require("./Partials");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("../styles/full.less");

var styles = {
  "button": "meepshop-meep-ui__mobileLayout-full__button",
  "buttonText": "meepshop-meep-ui__mobileLayout-full__buttonText",
  "subButton": "meepshop-meep-ui__mobileLayout-full__subButton",
  "pageItem": "meepshop-meep-ui__mobileLayout-full__pageItem",
  "buttonGroupSubmenu": "meepshop-meep-ui__mobileLayout-full__buttonGroupSubmenu",
  "root": "meepshop-meep-ui__mobileLayout-full__root",
  "openRoot": "meepshop-meep-ui__mobileLayout-full__openRoot",
  "inner": "meepshop-meep-ui__mobileLayout-full__inner",
  "bottomItem": "meepshop-meep-ui__mobileLayout-full__bottomItem",
  "divider": "meepshop-meep-ui__mobileLayout-full__divider",
  "content": "meepshop-meep-ui__mobileLayout-full__content",
  "popover": "meepshop-meep-ui__mobileLayout-full__popover",
  "popoverContent": "meepshop-meep-ui__mobileLayout-full__popoverContent",
  "popoverButton": "meepshop-meep-ui__mobileLayout-full__popoverButton",
  "bottom": "meepshop-meep-ui__mobileLayout-full__bottom",
  "arrow": "meepshop-meep-ui__mobileLayout-full__arrow"
};

var BottomItem = function BottomItem(_ref) {
  var page = _ref.page,
      background = _ref.background,
      color = _ref.color;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useButtonSettings = (0, _useButtonSettings2["default"])(page),
      title = _useButtonSettings.title;

  return /*#__PURE__*/_react["default"].createElement(_popover["default"], {
    overlayClassName: styles.popover,
    content: /*#__PURE__*/_react["default"].createElement("div", {
      className: styles.popoverContent,
      style: {
        background: background,
        color: color
      }
    }, page.pages.map(function (child) {
      return /*#__PURE__*/_react["default"].createElement(_Partials.Button, {
        styles: styles,
        className: styles.popoverButton,
        key: child.id,
        page: child
      });
    })),
    align: {
      offset: [0, 0],
      targetOffset: [0, 0]
    },
    placement: "topLeft",
    onVisibleChange: setOpen,
    trigger: "click"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.bottomItem
  }, title, open ? /*#__PURE__*/_react["default"].createElement(_UpOutlined["default"], {
    style: {
      fontSize: 12
    }
  }) : /*#__PURE__*/_react["default"].createElement(_DownOutlined["default"], {
    style: {
      fontSize: 12
    }
  })));
};

var Full = function Full(_ref2) {
  var color = _ref2.color,
      background = _ref2.background,
      open = _ref2.open,
      pagesProps = _ref2.pages,
      useIcon = _ref2.useIcon;

  var _useMobilePages = (0, _useMobilePages2.useMobilePages)(pagesProps),
      currencyPage = _useMobilePages.currencyPage,
      localePage = _useMobilePages.localePage,
      otherPages = _useMobilePages.otherPages,
      bottomPagesCount = _useMobilePages.bottomPagesCount;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.root, " ").concat(open ? styles.openRoot : ''),
    style: {
      background: background,
      color: color,
      fill: color
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.inner
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.content
  }, otherPages.map(function (page) {
    return /*#__PURE__*/_react["default"].createElement(_Partials.PageItem, {
      styles: styles,
      key: page.id,
      page: page,
      useIcon: useIcon,
      paddingLeftOffset: 16
    });
  }))), !!bottomPagesCount && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.bottom
  }, !!localePage && /*#__PURE__*/_react["default"].createElement(BottomItem, {
    page: localePage,
    background: background,
    color: color
  }), bottomPagesCount === 2 && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.divider
  }), !!currencyPage && /*#__PURE__*/_react["default"].createElement(BottomItem, {
    page: currencyPage,
    background: background,
    color: color
  })));
};

var _default = Full;
exports["default"] = _default;